import { render, staticRenderFns } from "./UnderstandContent.vue?vue&type=template&id=e2bd2abc&scoped=true&"
import script from "./UnderstandContent.vue?vue&type=script&lang=js&"
export * from "./UnderstandContent.vue?vue&type=script&lang=js&"
import style0 from "./UnderstandContent.vue?vue&type=style&index=0&id=e2bd2abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bd2abc",
  null
  
)

export default component.exports